export default __webpack_public_path__ + "56b8d1c0b7f4753b69001db56b46c79f.svg";